
import { Component, Vue, Prop } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { Form as ElForm } from 'element-ui'
import { setBatchReview } from '@/api/task/order'

@Component({
  name: 'batchReview',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private ordernumbers!: any[]

  private loading: boolean = false

  private infoFrom: any = {
    status: null,
    google_code: ''
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close')
  }

  private batchNotify() {
    ;(this.$refs.infoFrom as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        const data: any = {
          task_id: this.ordernumbers,
          ...this.infoFrom
        }
        await setBatchReview(data).then(res => {
          this.$message({
            message: 'Operation is successful!',
            type: 'success'
          })
          this.loading = false
          this.flagStr()
          this.back()
        })
      } else {
        return false
      }
    })
  }

  mounted() {}
}
